import RAPIER from '@dimforge/rapier3d-compat';
import packageJson from '../package.json';

// Type declarations for window.physics
export interface PhysicsAPI {
  applyImpulse: (
    element: Element,
    impulse: { x: number; y: number; z: number },
    point?: { x: number; y: number; z: number }
  ) => boolean;
}

declare global {
  interface Window {
    physics?: PhysicsAPI;
  }
}

import {
  CharacterBehavior,
  ColorCycleBehavior,
  ColorOnClickBehavior,
  DestroyOnDeath,
  FlammableBehavior,
  HealthBehavior,
  ObjectPickupBehavior,
  PlayerControlsBehavior,
  PlayerLifecycleBehavior,
  RandomCharacterMeshBehavior,
  RandomScaleBehavior,
  RandomWalkBehavior,
  RapierSystemBehavior,
  RotationBehavior,
  SpawnerBehavior,
  TemporaryBehavior,
  TransformBehavior,
  world,
} from "./behaviors";

// Initialize RAPIER (required for compat version)
await RAPIER.init();




// Parse JSON from import.meta.url and set gravity-y attribute
try {
  const url = new URL(import.meta.url);
  const configParam = url.searchParams.get('config');
  
  if (configParam) {
    const config = JSON.parse(decodeURIComponent(configParam));
    if (config.gravity !== undefined) {
      document.body.setAttribute('gravity-y', config.gravity.toString());
      console.log(`Set gravity-y attribute to: ${config.gravity}`);
    }
  } else {
    // Try parsing the entire search params as JSON if no specific config param
    const searchParamsObj = Object.fromEntries(url.searchParams);
    if (Object.keys(searchParamsObj).length > 0) {
      const config = searchParamsObj;
      if (config.gravity !== undefined) {
        document.body.setAttribute('gravity-y', config.gravity);
        console.log(`Set gravity-y attribute to: ${config.gravity}`);
      }
    }
  }
} catch (error) {
  console.warn('Could not parse config from URL:', error);
}

world.registerBehavior(RapierSystemBehavior); // Register physics system first
world.registerBehavior(TransformBehavior); // Register transform behavior (now includes rigidbody functionality)
world.registerBehavior(RotationBehavior);
world.registerBehavior(ColorCycleBehavior);
world.registerBehavior(ColorOnClickBehavior);
world.registerBehavior(CharacterBehavior);
world.registerBehavior(RandomWalkBehavior);
world.registerBehavior(HealthBehavior);
world.registerBehavior(DestroyOnDeath);
//world.registerBehavior(FlammableBehavior);
world.registerBehavior(SpawnerBehavior);
world.registerBehavior(RandomScaleBehavior);
world.registerBehavior(RandomCharacterMeshBehavior);
world.registerBehavior(ObjectPickupBehavior);
world.registerBehavior(PlayerControlsBehavior);
world.registerBehavior(PlayerLifecycleBehavior);
world.registerBehavior(TemporaryBehavior);

world.startObserving(document.body);

// Export physics methods globally
if (typeof window !== 'undefined') {
  window.physics = {
    applyImpulse: TransformBehavior.applyImpulseToElement,
  };
}